import React from 'react'
import Modal from 'react-bootstrap/Modal';
import AlertLottie from '../../Animation/alertLottie/AlertLottie';
const Error_Modal = (props) => {
    return (
        <>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="logOutmodal"
                backdrop="static"

            >

                <Modal.Body>
                    <section className='LogoutMain'>
                        <div className='succussFlex'>
                            <AlertLottie />
                            <div className='logoutinfo text-center'>
                                <p>{props.text || "Something Went Wrong"}</p>
                            </div>
                        </div>
                    </section>
                </Modal.Body>

            </Modal>
        </>
    )
}

export default Error_Modal